import React from "react";
import '.././PopupCommonStyle.css'
import styles from "./Style.module.css";
import { BtnSecondary } from "../../Buttons/BtnSecondary";
// import { BtnClose } from "../../Buttons/BtnClose/BtnClose";

export const ReschedulingExtendedPopup = ({active, handleClick, reschedulingMaxLimit}) => {
  // const handleClose = () => {
  //   handleClick(false);
  // };

  return (
    <div
      className={`popup ${styles.reschedulingExtendedPopup} ${
        active ? "show" : ""
      }`}
    >
      <div className={`${styles.popHeader} popup-header`}>
      {/* <BtnClose 
        handleClick={() => handleClose()} 
        title="Close" 
        customClass="popup-exit-btn"
      /> */}
      <h2 className="title">Reschedule Limit Reached</h2>
      <p className="titleSub">This booking can no longer be rescheduled as it has already been rescheduled {reschedulingMaxLimit} times.</p>
      </div>  
      <div className={`${styles.footer} popup-footer`}>
        <BtnSecondary
          label="Close"
          handleClick={handleClick}  
          customClass="w-100 no-icon"
        />
      </div>
    </div>
  );
};
